import defaultLogo from '~~/common/assets/images/map/default_logo.svg';
import defaultLogoSelected from '~~/common/assets/images/map/default_logo_selected.svg';
import defaultMarker from '~~/common/assets/images/map/default_marker.svg';
import defaultMarkerSelected from '~~/common/assets/images/map/default_marker_selected.svg';
import defaultMarkerDisabled from '~~/common/assets/images/map/default_marker_disabled.svg';

import packetaLogo from '~~/common/assets/images/map/packeta_logo.svg';
import packetaLogoSelected from '~~/common/assets/images/map/packeta_logo_selected.svg';
import packetaMarker from '~~/common/assets/images/map/packeta_marker.svg';
import packetaMarkerSelected from '~~/common/assets/images/map/packeta_marker_selected.svg';
import packetaMarkerDisabled from '~~/common/assets/images/map/packeta_marker_disabled.svg';

import foxpostLogo from '~~/common/assets/images/map/foxpost_logo.svg';
import foxpostLogoSelected from '~~/common/assets/images/map/foxpost_logo_selected.svg';
import foxpostMarker from '~~/common/assets/images/map/foxpost_marker.svg';
import foxpostMarkerSelected from '~~/common/assets/images/map/foxpost_marker_selected.svg';
import foxpostMarkerDisabled from '~~/common/assets/images/map/foxpost_marker_disabled.svg';

import glsLogo from '~~/common/assets/images/map/gls_logo.svg';
import glsLogoSelected from '~~/common/assets/images/map/gls_logo_selected.svg';
import glsMarker from '~~/common/assets/images/map/gls_marker.svg';
import glsMarkerSelected from '~~/common/assets/images/map/gls_marker_selected.svg';
import glsMarkerDisabled from '~~/common/assets/images/map/gls_marker_disabled.svg';

import coolomatLogo from '~~/common/assets/images/map/coolomat_logo.svg';
import coolomatLogoSelected from '~~/common/assets/images/map/coolomat_logo_selected.svg';
import coolomatMarker from '~~/common/assets/images/map/coolomat_marker.svg';
import coolomatMarkerSelected from '~~/common/assets/images/map/coolomat_marker_selected.svg';
import coolomatMarkerDisabled from '~~/common/assets/images/map/coolomat_marker_disabled.svg';

const ITEM_VARIANT_GLS = 'GLS';
const ITEM_VARIANT_PACKETA_Z_BOX = 'Packeta Z-BOX';
const ITEM_VARIANT_PACKETA_Z_PONT = 'Packeta Z-Pont';
const ITEM_VARIANT_FOXPOST_A_BOX = 'FOXPOST A-BOX';
const ITEM_VARIANT_FOXPOST_Z_BOX = 'FOXPOST Z-BOX';
const ITEM_VARIANT_COOLOMAT = 'Coolomat';

export function useMapLogos () {
  const defaultLogos = {
    logo: {
      selected: defaultLogoSelected,
      unselected: defaultLogo,
    },
    marker: {
      selected: defaultMarkerSelected,
      unselected: defaultMarker,
      disabled: defaultMarkerDisabled,
    },
  };
  const glsLogos = {
    logo: {
      selected: glsLogoSelected,
      unselected: glsLogo,
    },
    marker: {
      selected: glsMarkerSelected,
      unselected: glsMarker,
      disabled: glsMarkerDisabled,
    },
  };
  const foxpostLogos = {
    logo: {
      selected: foxpostLogoSelected,
      unselected: foxpostLogo,
    },
    marker: {
      selected: foxpostMarkerSelected,
      unselected: foxpostMarker,
      disabled: foxpostMarkerDisabled,
    },
  };
  const packetaLogos = {
    logo: {
      selected: packetaLogoSelected,
      unselected: packetaLogo,
    },
    marker: {
      selected: packetaMarkerSelected,
      unselected: packetaMarker,
      disabled: packetaMarkerDisabled,
    },
  };
  const coolomatLogos = {
    logo: {
      selected: coolomatLogoSelected,
      unselected: coolomatLogo,
    },
    marker: {
      selected: coolomatMarkerSelected,
      unselected: coolomatMarker,
      disabled: coolomatMarkerDisabled,
    },
  };
  // The pinCache is created so we do not generate thousands of objects but
  // reuse the same ones.
  const pinCache: Record<string, PinIcon> = {};
  return {
    getLeafletPin (str?: string) {
      const strString = str || 'undefined';
      if (!pinCache[strString]) {
        pinCache[strString] = new PinIcon(strString);
      }
      return pinCache[strString];
    },
    getLogo (selectedPointId?: unknown, item?: Item) {
      if (!item) {
        return;
      }
      const isSelected = selectedPointId === item.id;
      const logoGroup = getLogoGroup(item);
      return (isSelected
        ? logoGroup.logo.selected
        : logoGroup.logo.unselected
      );
    },
    getMarker (state?: { isSelected?: boolean, isDisabled: boolean }, item?: Item) {
      if (!item || !state) {
        return;
      }
      const { isSelected, isDisabled } = state;
      const logoGroup = getLogoGroup(item);
      if (isSelected) {
        return logoGroup.marker.selected;
      } else if (isDisabled) {
        return logoGroup.marker.disabled;
      } else {
        return logoGroup.marker.unselected;
      }
    },
  };

  function getLogoGroup (item?: Item) {
    let logos = defaultLogos;
    if (item) {
      if (item.variant === ITEM_VARIANT_GLS) {
        logos = glsLogos;
      } else if (item.variant === ITEM_VARIANT_FOXPOST_A_BOX || item.variant === ITEM_VARIANT_FOXPOST_Z_BOX) {
        logos = foxpostLogos;
      } else if (item.variant === ITEM_VARIANT_PACKETA_Z_BOX || item.variant === ITEM_VARIANT_PACKETA_Z_PONT) {
        logos = packetaLogos;
      } else if (item.variant === ITEM_VARIANT_COOLOMAT) {
        logos = coolomatLogos;
      }
    }
    return logos;
  }
}

type ItemVariant = (
  | typeof ITEM_VARIANT_GLS
  | typeof ITEM_VARIANT_PACKETA_Z_BOX
  | typeof ITEM_VARIANT_PACKETA_Z_PONT
  | typeof ITEM_VARIANT_FOXPOST_A_BOX
  | typeof ITEM_VARIANT_FOXPOST_Z_BOX
  | typeof ITEM_VARIANT_COOLOMAT
);

interface Item {
  id: unknown,
  variant: ItemVariant,
}

class PinIcon {
  public iconUrl: string | undefined;
  public iconSize = [40, 48];
  public iconAnchor = [26, 64];
  public popupAnchor = [0, -64];
  constructor (str?: string) {
    this.iconUrl = str;
  }
}
